import { FilterOperator } from '@nemuru-eng/js-api-client';

interface queryFiltersStringBuilderProps {
  filters: { operator: FilterOperator; value?: string | string[]; field: string }[];
}

const serializeFilterValue = (value: string | string[] | undefined): string | undefined => {
  if (value === undefined) return undefined;
  if (Array.isArray(value)) {
    return value.length ? value.join(',') : undefined;
  }
  return value;
};

export const queryFiltersStringBuilder = ({ filters }: queryFiltersStringBuilderProps) => {
  let queryFilters = '';
  filters &&
    filters.map((filter, index) => {
      const serialized = serializeFilterValue(filter.value);
      queryFilters = `${queryFilters}&filters[${index}][field]=${mapField(filter.field)}&filters[${index}][operator]=${
        filter.operator
      }${serialized ? `&filters[${index}][value]=${serialized}` : ''}`;
    });

  return queryFilters;
};
const mapField = (field) => {
  const mappedField = fieldsMap[field];
  if (!mappedField) {
    return field;
  }
  return mappedField;
};

const fieldsMap = {
  agent_name: 'agent_id',
};
